(() => {
  let lastTrigger = null;
  const getModal = () => document.querySelector('[data-cc-bms-modal]');

  const closeModal = () => {
    const modal = getModal();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('cc-bms-is-open');
    if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
  };

  const openModal = (trigger) => {
    const modal = getModal();
    if (!modal || !modal.hidden) return;
    lastTrigger = trigger;
    modal.hidden = false;
    document.body.classList.add('cc-bms-is-open');
    const closeButton = modal.querySelector('button[data-cc-bms-close]');
    if (closeButton) closeButton.focus();
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    const trigger = target.closest('[data-cc-bms-trigger]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (target.closest('[data-cc-bms-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = getModal();
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = Array.from(modal.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
